import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import InputLabel from "@material-ui/core/InputLabel";

const useStyles = makeStyles(theme => ({
  formControlRtl: {
    right: "-10px",
    left: "auto",
  },
}));

const IntlInputLabel = props => {
  const classes = useStyles();
  const { i18n } = useTranslation();
  return (
    <InputLabel
      {...props}
      classes={{
        formControl: clsx({
          [classes.formControlRtl]: i18n.dir() === "rtl",
        }),
      }}
    >
      {props.children}
    </InputLabel>
  );
};

export default IntlInputLabel;
